import React from 'react'
import SunsetMessage from './components/SunsetMessage'
// import Content from "./components/Content";

const Audiobook: React.FC = () => {
  return (
    <section 
      id="audiobook-section"
      className="
      w-full 
      pt-[150px] 
      m-auto 
      max-w-[492px] 
      pb-[62px] 
      flex 
      items-center 
      justify-center 
      relative 
      overflow-hidden 
      p-5

      lg:max-w-none
      ">

      {/*<Content/>*/}
      <SunsetMessage />
    </section>
  )
}

export default Audiobook